import { render, staticRenderFns } from "./Dispositivos.vue?vue&type=template&id=5c455900&scoped=true"
import script from "./Dispositivos.vue?vue&type=script&lang=ts"
export * from "./Dispositivos.vue?vue&type=script&lang=ts"
import style0 from "./Dispositivos.vue?vue&type=style&index=0&id=5c455900&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c455900",
  null
  
)

export default component.exports